export default "__VITE_ASSET__CqM7567e__"